module.exports = __webpack_public_path__ + "static/img/store-icon2.7e9eb71.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/store-icon2.png
// module id = U1Cq
// module chunks = 1